/** Three centered columns, same rhythm as the mobile menu mock. Desktop Übersicht may add columns. */
export const navTileGridClass =
  'mx-auto grid w-max max-w-full justify-center gap-x-4 gap-y-2.5 [grid-template-columns:repeat(3,min(5.375rem,calc((100vw-4.5rem)/3)))] lg:w-full lg:max-w-none lg:justify-start lg:gap-4 lg:[grid-template-columns:repeat(auto-fill,minmax(4.75rem,6rem))]';
